import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Privacy() {
  const { t } = useTranslation();
  const lastUpdated = '2025-09-29';
  const company = 'JustDev OÜ';
  const regCode = '16241237';
  const address = 'Liivaoja 4b, 10155 Tallinn, Estonia';
  const domain = 'threatcompass.eu';
  const contact = 'contact@threatcompass.eu';
  const zonePolicyUrl = 'https://www.zone.ee/en/zone-media-ou-privacy-policy/';

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="mb-4">
            <h1 className="text-2xl font-bold text-gray-900">{t('legal.privacy.title')}</h1>
          </div>
          <p className="text-sm text-gray-500 mb-8">{t('legal.lastUpdated', { date: lastUpdated })}</p>

          <p className="text-gray-700 mb-4">{t('legal.privacy.intro', { domain, company, regCode })}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s1Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.privacy.s1Body', { company, address, contact })}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s2Title')}</h2>
          <p className="text-gray-700 mb-2">{t('legal.privacy.s2PublicTitle')}</p>
          <ul className="list-disc pl-6 text-gray-700 mb-4">
            <li>{t('legal.privacy.s2PublicItem1')}</li>
            <li>{t('legal.privacy.s2PublicItem2')}</li>
          </ul>
          <p className="text-gray-700 mb-2">{t('legal.privacy.s2AiTitle')}</p>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            <li>{t('legal.privacy.s2AiItem1')}</li>
            <li>{t('legal.privacy.s2AiItem2')}</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s3Title')}</h2>
          <ul className="list-disc pl-6 text-gray-700 mb-4">
            <li>{t('legal.privacy.s3Item1')}</li>
            <li>{t('legal.privacy.s3Item2')}</li>
            <li>{t('legal.privacy.s3Item3')}</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s4Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.privacy.s4Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s5Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.privacy.s5Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s6Title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legal.privacy.s6Body1')}{' '}
            <a className="text-blue-600 hover:underline" href={zonePolicyUrl} target="_blank" rel="noreferrer">
              {t('legal.privacy.zoneLinkText')}
            </a>
            {t('legal.privacy.s6Body2')}
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s7Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.privacy.s7Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s8Title')}</h2>
          <ul className="list-disc pl-6 text-gray-700 mb-4">
            <li>{t('legal.privacy.s8Item1')}</li>
            <li>{t('legal.privacy.s8Item2')}</li>
            <li>{t('legal.privacy.s8Item3')}</li>
          </ul>
          <p className="text-gray-700 mb-6">{t('legal.privacy.s8Body', { contact })}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s9Title')}</h2>
          <p className="text-gray-700 mb-4">{t('legal.privacy.s9Body')}</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">{t('legal.privacy.s10Title')}</h2>
          <p className="text-gray-700">{t('legal.privacy.s10Body')}</p>
        </div>
      </div>
    </div>
  );
}
